module.exports = __webpack_public_path__ + "static/img/ic_circle.7e2ec9c.png";